import { MatterRecordEntryPoint, MatterRecordType } from '@/analytics/enums/matter-record.enums'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent, type AnalyticsEventProperties } from '@/analytics/schema/events.schema'
/** Card ids from the build modal. Product names live on MatterRecordType. */
type MatterRecordCardType = 'billing' | 'chronology' | 'timeline'

type MatterRecordEvent =
  | AnalyticsEvent.MatterRecordBuildClicked
  | AnalyticsEvent.MatterRecordTypeSelected
  | AnalyticsEvent.MatterRecordBuildContinued
  | AnalyticsEvent.MatterRecordExistingOpened

const recordTypeByCard: Record<MatterRecordCardType, MatterRecordType> = {
  timeline: MatterRecordType.Timeline,
  chronology: MatterRecordType.MedicalChronology,
  billing: MatterRecordType.MedicalBillingSummary,
}

const recordTypeBySidebarItemId: Record<string, MatterRecordType> = {
  timeline: MatterRecordType.Timeline,
  chronology: MatterRecordType.MedicalChronology,
  'billing-summary': MatterRecordType.MedicalBillingSummary,
}

function trackMatterRecord<T extends MatterRecordEvent>(track: TrackEventFn, event: T, props: AnalyticsEventProperties[T]) {
  track(event, props, { suppressFeatureInheritance: true })
}

export function trackMatterRecordBuildClicked(track: TrackEventFn, matterId: string) {
  trackMatterRecord(track, AnalyticsEvent.MatterRecordBuildClicked, { matterId })
}

export function trackMatterRecordTypeSelected(track: TrackEventFn, matterId: string, recordType: MatterRecordCardType) {
  trackMatterRecord(track, AnalyticsEvent.MatterRecordTypeSelected, { matterId, matterRecordType: recordTypeByCard[recordType] })
}

export function trackMatterRecordBuildContinued(track: TrackEventFn, matterId: string, recordType: MatterRecordCardType) {
  trackMatterRecord(track, AnalyticsEvent.MatterRecordBuildContinued, { matterId, matterRecordType: recordTypeByCard[recordType] })
}

export function trackMatterRecordExistingFromModal(track: TrackEventFn, matterId: string, recordType: MatterRecordCardType) {
  trackMatterRecord(track, AnalyticsEvent.MatterRecordExistingOpened, {
    matterId,
    matterRecordType: recordTypeByCard[recordType],
    matterRecordEntryPoint: MatterRecordEntryPoint.ModalChip,
  })
}

export function trackSidebarMatterRecordOpened(track: TrackEventFn, matterId: string, itemId: string) {
  const matterRecordType = recordTypeBySidebarItemId[itemId]
  if (!matterRecordType) return
  trackMatterRecord(track, AnalyticsEvent.MatterRecordExistingOpened, {
    matterId,
    matterRecordType,
    matterRecordEntryPoint: MatterRecordEntryPoint.Sidebar,
  })
}
